import React from 'react';
import PropTypes from 'prop-types';
import {
    isEmptyDataset
} from "./utils/ChartHelpers";
import infoIcon from '../img/icon-info.png';
//import {Tooltip} from '@progress/kendo-react-tooltip';
import ReactTooltip from 'react-tooltip';
import localize from '../hoc/localize';
//import { CanvasJS } from '../lib/canvasjs.react';

var CanvasJSReact = require("../lib/canvasjs.react");
var CanvasJSChart = CanvasJSReact.CanvasJSChart;

//const TooltipContentTemplate = (props) => {
//    return (
//        <div className="som-tooltip" ><strong>{props.title}</strong></div>
//    );

//}

class CanvasJSChartContainer extends React.Component {
    static propTypes = {
        title: PropTypes.string,
        data: PropTypes.object,
        options: PropTypes.object
    }

    state = {
        isNarrow: false
    }

    constructor(props) {
        super(props);
            this.handleResize = this.handleResize.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize = () => {
            if (window.innerWidth < 1000) {
                this.setState({isNarrow: true})
            }
            else {
                this.setState({isNarrow: false})
            }
    };

    //!DBTRANS! @m0010@ No data available to show. !DEVNOTE! Shown when data missing from chart
    //!DBTRANS! @m0540@ Profit !DEVNOTE! Series Title
    //!DBTRANS! @m0541@ Inventory value mix of Obsolete parts, Aged Inventory which has not sold any in last 12 month, Slow Moving parts that have sold less than 6 in last 12 month, Average Moving parts that have sold 6 to 24 in last 12 month, Fast Moving parts that have sold more than 24 in last 12 month !DEVNOTE! 
    //!DBTRANS! @m0542@ Year-To-Date Profit Comparison is comparing profit of each month of current year represented by blue bars to the profit made on the same month of previous year represented by green bars and the positive or negative growth percentage is represented by the orange line. If any of the bars missing means that data is not provided or the month is yet to finish. !DEVNOTE! 
    //!DBTRANS! @m0543@ Sales revenue of the selected month by two main part groups of General Merchandise (GM) and Parts & Accessories (P&A) !DEVNOTE! 

    render() {
        const noData = isEmptyDataset(this.props.data);
        var description = ""
        switch(this.props.title) {
            case 'm0001':
                description = this.props.returnLocalizedString("m0543");
                break;
            case 'm0002':
                description = this.props.returnLocalizedString("m0542");
                break;
            case 'm0003':
                description = this.props.returnLocalizedString("m0541");
                break;
            default:
                break;
            }
        // render a placeholder for the chart, along with a tooltip
        // if no data to show, then show a "no data available" message
        // otherwise, render out the chart
        return (
            <React.Fragment>
                <ReactTooltip className="som-tooltip" place = {this.state.isNarrow ? "right" : "top"} html={true} type="dark" effect="solid" event="mouseover"
                    eventOff="mouseout" offset={{ top: -5 }} multiline={true} />

                <div className={`chart-placeholder ${noData ? 'empty' : ''}`}>

                    <img src={infoIcon} className="info" data-tip={description} alt="" />

                    {noData ? (
                        <React.Fragment>
                            <div className="title">{this.props.returnLocalizedString(this.props.title)}</div>
                            <p className="t-center"> {this.props.returnLocalizedString("m0010")} </p>
                        </React.Fragment>
                    ) : (
                            <CanvasJSChart {...this.props} />
                        )}


                </div>
            </React.Fragment>
        );


    }
}
export default localize(CanvasJSChartContainer);


// WEBPACK FOOTER //
// ./src/components/CanvasJSChartContainer.js